module.exports = __webpack_public_path__ + "img/jingdian.ac38d7b1.png";